import enDashboard from './dashboard/dashboard.json'
import enStats from './stats/stats.json'
import enAccreditation from './accreditation/accreditation.json'
import enCms from './cms/cms.json'
import enAuth from './auth/auth.json'
import enCommon from './common/common.json'
import enCompetition from './competition/competition.json'
import enGeneralApplications from './general-applications/general-applications.json'
import enLeague from './league/league.json'
import enMatch from './match/match.json'
import enNotification from './notification/notification.json'
import enOrganization from './organization/organization.json'
import enPhase from './phase/phase.json'
import enRecreation from './recreation/recreation.json'
import enRoles from './roles/roles.json'
import evSeason from './season/season.json'
import enShared from './shared/shared.json'
import enSponsor from './sponsor/sponsor.json'
import enSport from './sport/sport.json'
import enUnit from './unit/unit.json'
import enUser from './user/user.json'
import enUtils from './utils/utils.json'

export const en = {
    dashboard: enDashboard,
    stats: enStats,
    competition: enCompetition,
    common: enCommon,
    accreditation: enAccreditation,
    notification: enNotification,
    league: enLeague,
    roles: enRoles,
    season: evSeason,
    sponsor: enSponsor,
    unit: enUnit,
    user: enUser,
    organization: enOrganization,
    sport: enSport,
    shared: enShared,
    'general-applications': enGeneralApplications,
    phase: enPhase,
    utils: enUtils,
    auth: enAuth,
    match: enMatch,
    recreation: enRecreation,
    cms: enCms,
}
